import {Button} from "../../../components";
import React, {useRef} from "react";
import {formatCurrency} from "../../../utils/format";
import {AssetsSummary} from "../../models/Assets";
import {LegalEntityReadModel} from "../../models/Ownership";
import OutOfEstateAssetList from "./OutOfEstateAssetList";
import {hasOutOfEstateAssets, hasOutOfEstateLiabilities} from "../../AssetSummary/common/utils";
import {calculateOutOfEstateTotalValue} from "../../AssetSummary/common/AssetSummaryCalculator";
import {useAnalyticsTrackers} from "../../../utils/useAnalyticsTrackers";

export type OutOfEstateContainerProps = {
    showOutOfEstate: boolean,
    onClickShowOutOfEstate: (show: boolean) => void
    assets: AssetsSummary,
    legalEntities: LegalEntityReadModel[]
    showDeathBenefit?: boolean;
    isReportingCall?: boolean;
    onDeleteLegalEntity: (legalEntityId: string) => void
}
const OutOfEstateContainer = ({
                                  showOutOfEstate,
                                  onClickShowOutOfEstate,
                                  assets,
                                  legalEntities,
                                  showDeathBenefit = false,
                                  isReportingCall = false,
                                  onDeleteLegalEntity
                              }: OutOfEstateContainerProps) => {

    const outOfEstateTotalValue = calculateOutOfEstateTotalValue(assets, showDeathBenefit)

    const openTimeRef = useRef<number | null>(null);
    const { page } = useAnalyticsTrackers("enableAssetsGoogleAnalytics");

    if (showOutOfEstate) {
        openTimeRef.current = window.performance.now();
    }

    const showHideOutOfEstate = (hideShow:boolean) => {
        if (openTimeRef.current && hideShow === false) {
            const duration = Math.round((window.performance.now() - openTimeRef.current) / 1000);
            page(`Expand_OutOfEstateAccordion`, {cd4_duration: duration});
        }
        onClickShowOutOfEstate(hideShow)
    }

    return <>
        {showOutOfEstate &&
            <>
                <div className="section-header">
                    <h3>
                        Out of estate assets total <b>{formatCurrency(outOfEstateTotalValue).trim()}</b>:
                    </h3>
                    <Button
                        kind='borderless'
                        onClick={() => showHideOutOfEstate(false)}>
                        Hide out of estate assets
                    </Button>
                </div>
                <OutOfEstateAssetList assets={assets}
                                      legalEntities={legalEntities}
                                      showDeathBenefit={showDeathBenefit}
                                      isReportingCall={isReportingCall}
                                      onDeleteLegalEntity={onDeleteLegalEntity}/>
            </>}
        {(hasOutOfEstateAssets(assets) || hasOutOfEstateLiabilities(assets)) &&
            <Button
                kind='secondary'
                rounded
                onClick={() => {
                    showHideOutOfEstate(!showOutOfEstate);
                }}>
                {showOutOfEstate ? "Hide out of estate assets" : "Show out of estate assets"}
            </Button>}
    </>
};


export default OutOfEstateContainer;